import { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ChevronIcon } from 'src/components/ChevronIcon';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import {
  doesToolSupportMaxChars,
  GENERATION_TOOL,
  getToolDescription,
} from 'src/data/generationTool';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { useStyles } from './useStyles';

const DOT = '•';
export const FormulaItem = ({
  className,
  classes,
  generationTool,
  title,
  onClick,
  disabled,
  displayToolHeader,
  maxChars,
  isMenuOpen,
}) => {
  const styles = useStyles({ classes });
  const [buttonDirection, setButtonDirection] = useState(ROTATE_DIRECTION.down);
  const toolHeader = getToolDescription(generationTool);
  const displayMaxChars = doesToolSupportMaxChars(generationTool) && maxChars;

  const handleClick = () => {
    onClick();
  };

  useEffect(() => {
    if (isMenuOpen) {
      setButtonDirection(ROTATE_DIRECTION.right);
    } else {
      setButtonDirection(ROTATE_DIRECTION.down);
    }
  }, [isMenuOpen]);

  return (
    <CustomButtonBase
      className={cx(styles.root, className, {
        [styles.disabled]: disabled,
        [styles.active]: isMenuOpen,
      })}
      onClick={handleClick}
      disabled={disabled}
    >
      <div className={styles.texts}>
        {displayToolHeader && (
          <CustomTypography
            className={styles.subtitle}
            variant={TYPOGRAPHY_VARIANT.regular12}
          >
            {toolHeader}
          </CustomTypography>
        )}

        <div className={styles.mainTexts}>
          {displayMaxChars && (
            <>
              <CustomTypography
                className={styles.maxCharsTitle}
                variant={TYPOGRAPHY_VARIANT.regular14}
              >
                Max chars: {maxChars}
              </CustomTypography>
            </>
          )}
          {displayMaxChars && title && (
            <CustomTypography
              className={styles.dot}
              variant={TYPOGRAPHY_VARIANT.regular14}
            >
              {DOT}
            </CustomTypography>
          )}
          <CustomTooltip title={title}>
            <CustomTypography
              className={styles.formulaTitle}
              variant={TYPOGRAPHY_VARIANT.regular14}
            >
              {title}
            </CustomTypography>
          </CustomTooltip>
        </div>
      </div>

      <ChevronIcon
        className={styles.icon}
        direction={buttonDirection}
      />
    </CustomButtonBase>
  );
};

FormulaItem.propTypes = {
  className: PropTypes.string,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)).isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  displayToolHeader: PropTypes.bool,
};
FormulaItem.defaultProps = {
  className: null,
  disabled: false,
  displayToolHeader: false,
};
